export const tags = {
  MEASURE_PARAMS_TAG: 'MEASURE_PARAMS_TAG',
  MEASURE_TAG: 'MEASURE_TAG',
  CREATE_MEASURE_TAG: 'CREATE_MEASURE_TAG',
  DELETE_MEASURE_TAG: 'DELETE_MEASURE_TAG',
  PROGRAM_BLOCK_TAG: 'PROGRAM_BLOCK_TAG',
  CREATE_PROGRAM_BLOCK_TAG: 'CREATE_PROGRAM_BLOCK_TAG',
  DELETE_PROGRAM_BLOCK_TAG: 'DELETE_PROGRAM_BLOCK_TAG',
  DATASOURCE_PROGRAM_TAG: 'DATASOURCE_PROGRAM_TAG',
  CREATE_DATASOURCE_PROGRAM_TAG: 'CREATE_DATASOURCE_PROGRAM_TAG',
  DELETE_DATASOURCE_PROGRAM_TAG: 'DELETE_DATASOURCE_PROGRAM_TAG',
  CREATE_DATASOURCE_PROGRAM_BLOCK_TAG: 'CREATE_DATASOURCE_PROGRAM_BLOCK_TAG',
  DELETE_DATASOURCE_PROGRAM_BLOCK_TAG: 'DELETE_DATASOURCE_PROGRAM_BLOCK_TAG',
  DATASOURCE_PROGRAM_BLOCK_TAG: 'DATASOURCE_PROGRAM_BLOCK_TAG',
  OBSERVATION_TYPES_TAG: 'OBSERVATION_TYPES_TAG',
  PHENOMENON_TYPES_TAG: 'PHENOMENON_TYPES_TAG',
  PROGRAM_TAG: 'PROGRAM_TAG',
  PROGRAMS_BY_DATASOURCE_TAG: 'PROGRAMS_BY_DATASOURCE_TAG',
  PROGRAM_BY_DATASOURCE_TAG: 'PROGRAM_BY_DATASOURCE_TAG',
  DELETE_PROGRAM_TAG: 'DELETE_PROGRAM_TAG',
};
